// eslint-disable import/no-default-export no-unused-expression
// eslint:disable max-func-body-length
import { BowtieCaseDraft, BowtieCaseModalContainer, BowtieCaseView, BowtieScreen } from '../area/bowtie/bowtie-screen';
import { Case } from '../area/case';
import { CaseCreator } from '../area/case/create';
import { Draft } from '../area/case/draft';
import { CaseDuplicateCreator } from '../area/case/duplicate';
import { Editor } from '../area/case/edit';
import { DashboardCaseDraft, DashboardCaseModalContainer, DashboardCaseView, DashboardRoute } from '../area/dashboard/dashboard-route';
import { ReportRoute } from '../area/company-report/report-route';
import { Startup, StartupDashboardCaseDraft, StartupDashboardCaseModalContainer, StartupDashboardCaseView } from '../area/startup/startup';
import { ImportView } from '../area/import/import-view';
import { AppSetting } from 'dependencies/appsettings';
import { Layout } from '../shell/default/layout';
import { FavouriteCaseDraft, FavouriteCaseModalContainer, FavouriteCaseView, FavouriteRoute } from '../area/favourite/favourite-route';
import * as React from 'react';
import { routeConstants } from './route-constants';
import { UserEditView } from 'app/area/administration';
import { ChangeCaseType } from '../area/case/draft/change-casetype';
import { MyDownloads } from 'app/area/my-downloads/my-downloads';
import { RoleEditView } from 'app/area/administration/edit/role/role-edit';
import { RoleSearchView } from 'app/area/administration/list/roles/role-search';
import { UsersSearchView } from 'app/area/administration/list/users/user-search';
import { IndicatorFactorsBase } from 'app/area/indicator-factors/codetable-base';
import { IndicatorFactorsList } from 'app/area/indicator-factors/list/codetable-list';
import { IndicatorFactorsItem } from 'app/area/indicator-factors/item/codetable-item';
import { CodetableBase } from 'app/area/codetable/codetable-base';
import { CodetableList } from 'app/area/codetable/list/codetable-list';
import { CodetableItem } from 'app/area/codetable/item/codetable-item';
import { LinkCodes } from 'app/area/link-codes/link-codes';
import { SelectSavedReportSelector } from 'app/area/saved-reports/select-saved-report';
import { CodeSelector } from 'app/area/code-selector/code-selector';
import { UserProfileView } from 'app/area/user-profile/user-profile';
import { Messages } from 'app/area/messages/messages';
import { withWaitForAccessInfo } from 'app/routes/wait-for-access-info';
import { AdministrationMessagesList } from 'app/area/messages-administration/list/messages-list';
import { AdministrationMessageForm } from 'app/area/messages-administration/form/message-form';
import { DashboardAdminList } from 'app/area/dashboard-administration/list/dashboard-admin-list';
import { DashboardForm } from 'app/area/dashboard-administration/form/dashboard-form';
import { DashboardSavedReports } from 'app/area/dashboard-administration/saved-reports/dashboard-saved-reports';
import { TextConfigurationList } from 'app/area/text-configuration/list/text-configuration-list';
import { CodeDescriptionList } from 'app/area/text-configuration/list/code-description-list';
import { TextConfigurationForm } from 'app/area/text-configuration/form/text-configuration-form';
import { SavedFavouriteRoute } from 'app/area/favourite/saved-favourite-route';
import { CreateFavouriteDraftRoute } from 'app/area/favourite/create-favourite-draft-route';
import { withSavedCompanyReport } from 'app/area/saved-reports/saved-company-report';
import { CreateCompanyReportFavouriteRoute } from 'app/area/company-report/create-company-report-favourite-route';
import { Route } from 'react-router-dom';
import { withRouter } from 'app/components/enhancers/with-router';
import { SavedReportRoute } from 'app/area/company-report/saved-report-route';
import { generateRouteLevels, generateRouteCodetablePaths } from './route-helpers';
import { CompanyReportsAdminList } from 'app/area/company-reports-administration/list/list';
import { CompanyReportForm } from 'app/area/company-reports-administration/form/company-report-form';
import { withSavedDashboard } from 'app/area/saved-reports/saved-dashboard';
import { SavedDashboardRoute } from 'app/area/dashboard/saved-dashboard-route';
import { CreateDashboardFavouriteRoute } from 'app/area/dashboard/create-dashboard-favourite-route';
import { FavouriteAdminList } from 'app/area/favourite-administration/list/favourite-admin-list';
import { FavouriteForm } from 'app/area/favourite-administration/form/favourite-form';
import { ImportSetsAdminList } from 'app/area/import-sets-administration/list/list';
import { ImportSetForm } from 'app/area/import-sets-administration/form/import-set-form';
import { CodeMappings } from 'app/area/code-mappings/code-mappings';
import { ImportMappings } from 'app/area/import-mappings/import-mappings';
import { Logout } from 'app/area/auth/logout';
import { ExternalUrlsAdminList } from 'app/area/external-urls-administration/list/list';
import { ExternalUrlForm } from 'app/area/external-urls-administration/form/external-url-form';
import { ExternalUrlGroupsList } from 'app/area/external-url-groups/list/list';
import { ExternalUrlGroupsForm } from 'app/area/external-url-groups/form/external-url-form';
import { SubscriberGroupsList } from 'app/area/subscriber-groups/list/list';
import { SubscriberGroupForm } from 'app/area/subscriber-groups/form/subscriber-group-form';
import { UserMembers } from 'app/area/subscriber-groups/user-members/user-members';
import { ExperienceTransferList } from 'app/area/experience-transfer/list/list';
import { ExperienceTransferForm } from 'app/area/experience-transfer/form/experience-transfer-form';
import { AuthProvider } from 'app/shell/auth-provider';
import { authProvider } from 'app/startup/default/auth';
import { OperationsList } from 'app/area/experience-transfer/operations/list';

/**
 * > It's important to avoid nested routes whenever possible to reduce app complexity.
 *
 * Mapping URLs to areas and component views
 * See router docs at: https://github.com/reactjs/react-router/tree/master/docs
 */

const translations = AppSetting.Translations as any;
const texts = (translations || {}).app;
const NotFound: any = () => (<div>{texts && texts.logoutNotFoundError}</div>);
const SavedFavouriteWithRouter = withRouter(SavedFavouriteRoute);
const FavouriteRouteWithRouter = withRouter(FavouriteRoute);
const DraftWithRouter = withRouter(Draft);
const CaseCreatorComponent = withRouter(CaseCreator());
const CodeSelectorWithRouter = withRouter(CodeSelector);
const DashboardWithRouter = withRouter(DashboardRoute);
const EditorWithRouter = withRouter(Editor());
const StartupWithRouter = withRouter(Startup);
const UserProfileViewWithRouter = withRouter(UserProfileView);
const SavedReportRouteWithRouter = withRouter(SavedReportRoute);
const CreateCompanyReportFavouriteRouteWithRouter = withRouter(CreateCompanyReportFavouriteRoute);
const CreateDashboardFavouriteRouteWithRouter = withRouter(CreateDashboardFavouriteRoute);
const ReportRouteWithRouter = withRouter(ReportRoute);
const SelectDashboard = withRouter(withSavedDashboard(SelectSavedReportSelector));
const SelectCompanyReport = withRouter(withSavedCompanyReport(SelectSavedReportSelector));
const SelectSavedReport = withRouter(SelectSavedReportSelector);
const CaseWithRouter = withRouter(Case);
const UserSearchViewWithAccessInfo = withRouter(withWaitForAccessInfo(UsersSearchView));
const RolesSearchViewWithAccessInfo = withRouter(withWaitForAccessInfo(RoleSearchView));
const RoleEditViewWithAccessInfo = withRouter(withWaitForAccessInfo(RoleEditView));
const UserEditViewWithAccessInfo = withRouter(withWaitForAccessInfo(UserEditView));
const LinkCodesWithRouter = withRouter(withWaitForAccessInfo(LinkCodes));
const CodetableBaseWithRouter = withRouter(CodetableBase);
const IndicatorFactorsBaseWithRouter = withRouter(IndicatorFactorsBase);
const AdministrationMessageFormWithRouter = withRouter(withWaitForAccessInfo(AdministrationMessageForm));
const AdministrationMessagesListWithAccessInfo = withRouter(withWaitForAccessInfo(AdministrationMessagesList));
const CodetableListWithRouter = withRouter(CodetableList);
const CodetableItemWithRouter = withRouter(CodetableItem);
const IndicatorFactorsListWithRouter = withRouter(IndicatorFactorsList);
const IndicatorFactorsItemWithRouter = withRouter(IndicatorFactorsItem);
const TextConfigurationListWithRouter = withRouter(withWaitForAccessInfo(TextConfigurationList));
const TextConfigurationFormWithRouter = withRouter(withWaitForAccessInfo(TextConfigurationForm));
const CodeDescriptionListWithRouter = withRouter(withWaitForAccessInfo(CodeDescriptionList));
const DashboardAdminListWithRouter = withRouter(withWaitForAccessInfo(DashboardAdminList));
const DashboardFormWithRouer = withRouter(withWaitForAccessInfo(DashboardForm));
const DashboardSavedReportsWithRouter = withRouter(withWaitForAccessInfo(DashboardSavedReports));
const SavedDashboardRouteWithRouter = withRouter(SavedDashboardRoute);
const CaseDuplicateCreatorWithRouter = withRouter(CaseDuplicateCreator);
const BowtieScreenWithRouter = withRouter(BowtieScreen);
const ImportViewWithRouter = withRouter(ImportView);
const CompanyReportsAdminListWithAccessInfo = withRouter(withWaitForAccessInfo(CompanyReportsAdminList));
const CompanyReportFormWithAccessInfo = withRouter(withWaitForAccessInfo(CompanyReportForm));
const ChangeCaseTypeWithRouter = withRouter(ChangeCaseType);
const FavouriteAdminListWithAccessInfo = withRouter(withWaitForAccessInfo(FavouriteAdminList));
const FavouriteFormWithRouter = withRouter(withWaitForAccessInfo(FavouriteForm));
const ImportSetsAdminListWithAccessInfo = withRouter(withWaitForAccessInfo(ImportSetsAdminList));
const ImportSetFormWithAccessInfo = withRouter(withWaitForAccessInfo(ImportSetForm));
const ExternalUrlsAdminListWithAccessInfo = withRouter(withWaitForAccessInfo(ExternalUrlsAdminList));
const ExternalUrlFormWithAccessInfo = withRouter(withWaitForAccessInfo(ExternalUrlForm));
const ExternalUrlGroupsListWithAccessInfo = withRouter(withWaitForAccessInfo(ExternalUrlGroupsList));
const ExternalUrlGroupsFormWithAccessInfo = withRouter(withWaitForAccessInfo(ExternalUrlGroupsForm));
const SubscriberGroupsListWithAccessInfo = withRouter(withWaitForAccessInfo(SubscriberGroupsList));
const SubscriberGroupsFormWithAccessInfo = withRouter(withWaitForAccessInfo(SubscriberGroupForm));
const ExperienceTransferListWithAccessInfo = withRouter(withWaitForAccessInfo(ExperienceTransferList));
const ExperienceTransferFormWithAccessInfo = withRouter(withWaitForAccessInfo(ExperienceTransferForm));
const OperationsListWithAccessInfo = withRouter(withWaitForAccessInfo(OperationsList));
const UserMembersWithRouter = withRouter(withWaitForAccessInfo(UserMembers));
const CodeMappingsListWithRouter = withRouter(withWaitForAccessInfo(CodeMappings));
const ImportMappingsWithRouter = withRouter(ImportMappings);

// eslint-disable-next-line import/no-default-export
export default 
  <Route element={<AuthProvider authProvider={authProvider}><Layout /></AuthProvider>}>    
    
    <Route path={routeConstants.startupView} element={<StartupWithRouter />}>
      <Route path={routeConstants.startupDashboard} element={<StartupDashboardCaseModalContainer  />}>
        {generateRouteLevels({ component: StartupDashboardCaseView, prefix: routeConstants.modalViewOpenCase })}
        {generateRouteLevels({ component: EditorWithRouter, prefix: routeConstants.modalViewOpenCase, suffix: routeConstants.edit })}
        {generateRouteLevels({ component: StartupDashboardCaseDraft, prefix: routeConstants.modalViewEditCase })}
        {generateRouteLevels({ 
          component: CaseCreatorComponent, prefix: routeConstants.modalViewOpenCase, suffix: routeConstants.createDraft 
        })}
        {generateRouteLevels({ 
          component: CaseDuplicateCreatorWithRouter, prefix: routeConstants.modalViewDuplicateCase
        })}
        {generateRouteLevels({ 
          component: CaseCreatorComponent, prefix: routeConstants.modalViewEditCase, suffix: routeConstants.createDraft 
        })}
        {generateRouteCodetablePaths({ 
          component: CodeSelectorWithRouter, levels: 7, prefix: routeConstants.modalViewEditCase, suffix: routeConstants.selectCodetableId 
        })}
        {generateRouteLevels({ 
          component: ChangeCaseTypeWithRouter, prefix: routeConstants.modalViewEditCase, suffix: routeConstants.changeCaseType 
        })}
        {generateRouteLevels({ 
          component: CodeSelectorWithRouter, prefix: routeConstants.modalViewEditCase, suffix: routeConstants.select  
        })}
      </Route>
    </Route>

    <Route path={routeConstants.favouriteView} element={<FavouriteRouteWithRouter />}>
      <Route element={<FavouriteCaseModalContainer  />}>
        {generateRouteLevels({ component: FavouriteCaseView, prefix: routeConstants.modalViewOpenCase })}
        {generateRouteLevels({ component: EditorWithRouter, prefix: routeConstants.modalViewOpenCase, suffix: routeConstants.edit })}
        {generateRouteLevels({ component: FavouriteCaseDraft, prefix: routeConstants.modalViewEditCase })}
        {generateRouteLevels({ 
          component: CaseCreatorComponent, prefix: routeConstants.modalViewOpenCase, suffix: routeConstants.createDraft 
        })}
        {generateRouteLevels({ 
          component: CaseCreatorComponent, prefix: routeConstants.modalViewEditCase, suffix: routeConstants.createDraft 
        })}
        {generateRouteLevels({ 
          component: CaseDuplicateCreatorWithRouter, prefix: routeConstants.modalViewDuplicateCase
        })}
        {generateRouteCodetablePaths({ 
          component: CodeSelectorWithRouter, levels: 7, prefix: routeConstants.modalViewEditCase, suffix: routeConstants.selectCodetableId 
        })}
        {generateRouteLevels({ 
          component: ChangeCaseTypeWithRouter, prefix: routeConstants.modalViewEditCase, suffix: routeConstants.changeCaseType 
        })}
        {generateRouteLevels({ 
          component: CodeSelectorWithRouter, prefix: routeConstants.modalViewEditCase, suffix: routeConstants.select  
        })}
      </Route>
    </Route>

    <Route path={routeConstants.createFavouriteDraft} element={<CreateFavouriteDraftRoute />} />
    <Route path={routeConstants.favouriteDraftNew} element={<CreateFavouriteDraftRoute />} />
    <Route path={routeConstants.savedFavouriteWithAction} element={<SavedFavouriteWithRouter />} />
    <Route path={routeConstants.savedFavourite} element={<SavedFavouriteWithRouter />} />
    {generateRouteLevels({ component: CaseWithRouter, prefix: routeConstants.caseView })}
    {generateRouteLevels({ component: DraftWithRouter, prefix: routeConstants.draftView })}
    <Route path={routeConstants.createDraft} element={<CaseCreatorComponent />} />
    <Route path={routeConstants.changeCaseType} element={<ChangeCaseTypeWithRouter />} />
    {generateRouteLevels({ component: EditorWithRouter, prefix: routeConstants.caseView, suffix: routeConstants.edit })}
    <Route path={routeConstants.caseDuplicate} element={<CaseDuplicateCreatorWithRouter />} />

    <Route path={routeConstants.dashboardFavourite} element={<CreateDashboardFavouriteRouteWithRouter />} />
    <Route path={routeConstants.dashboardView} element={<DashboardWithRouter />} >
      <Route path=":favouriteId">
        <Route element={<DashboardCaseModalContainer  />}>
          {generateRouteLevels({ component: DashboardCaseView, prefix: routeConstants.modalViewOpenCase })}
          {generateRouteLevels({ component: EditorWithRouter, prefix: routeConstants.modalViewOpenCase, suffix: routeConstants.edit })}
          {generateRouteLevels({ component: DashboardCaseDraft, prefix: routeConstants.modalViewEditCase })}
          {generateRouteLevels({ 
            component: CaseCreatorComponent, prefix: routeConstants.modalViewOpenCase, suffix: routeConstants.createDraft 
          })}
          {generateRouteLevels({ 
            component: CaseCreatorComponent, prefix: routeConstants.modalViewEditCase, suffix: routeConstants.createDraft 
          })}
          {generateRouteLevels({ 
            component: CaseDuplicateCreatorWithRouter, prefix: routeConstants.modalViewDuplicateCase
          })}
          {generateRouteCodetablePaths({ 
          component: CodeSelectorWithRouter, levels: 7, prefix: routeConstants.modalViewEditCase, suffix: routeConstants.selectCodetableId 
          })}
          {generateRouteLevels({ 
            component: ChangeCaseTypeWithRouter, prefix: routeConstants.modalViewEditCase, suffix: routeConstants.changeCaseType 
          })}
          {generateRouteLevels({ 
            component: CodeSelectorWithRouter, prefix: routeConstants.modalViewEditCase, suffix: routeConstants.select  
          })}
        </Route>
      </Route>
    </Route>
    <Route path={routeConstants.savedDashboard} element={<SavedDashboardRouteWithRouter />} />
    {[routeConstants.savedDashboardModifier1, routeConstants.savedDashboardModifier2, routeConstants.savedDashboardModifier1and2]
      .map(path =>
        <Route path={path} key={path} element={<SavedDashboardRouteWithRouter />} />
      )}

    <Route path={routeConstants.companyReportFavourite} element={<CreateCompanyReportFavouriteRouteWithRouter />} />
    <Route path={routeConstants.companyReportFavouriteDraft} element={<ReportRouteWithRouter />} />
    <Route path={routeConstants.companyReportView} element={<ReportRouteWithRouter />} />
    <Route path={routeConstants.savedCompanyReport} element={<SavedReportRouteWithRouter />} />
    {[routeConstants.savedCompanyReportModifier1, 
      routeConstants.savedCompanyReportModifier2, 
      routeConstants.savedCompanyReportModifier1and2]
      .map(path =>
        <Route path={path} key={path} element={<SavedReportRouteWithRouter />} />
      )}
    <Route path={routeConstants.userProfileMainView} element={<UserProfileViewWithRouter />} />
    <Route path={routeConstants.userProfileMainViewFocus} element={<UserProfileViewWithRouter />} />
    <Route path={routeConstants.userSearchView} element={<UserSearchViewWithAccessInfo />} />
    <Route path={routeConstants.rolesView} element={<RolesSearchViewWithAccessInfo />} />
    <Route path={routeConstants.bowtieView} element={<BowtieScreenWithRouter />}>
      <Route element={<BowtieCaseModalContainer  />}>
        {generateRouteLevels({ component: BowtieCaseView, prefix: routeConstants.modalViewOpenCase })}
        {generateRouteLevels({ component: EditorWithRouter, prefix: routeConstants.modalViewOpenCase, suffix: routeConstants.edit })}
        {generateRouteLevels({ component: BowtieCaseDraft, prefix: routeConstants.modalViewEditCase })}
        {generateRouteLevels({ 
          component: CaseCreatorComponent, prefix: routeConstants.modalViewOpenCase, suffix: routeConstants.createDraft 
        })}
        {generateRouteLevels({ 
          component: CaseCreatorComponent, prefix: routeConstants.modalViewEditCase, suffix: routeConstants.createDraft 
        })}
        {generateRouteCodetablePaths({ 
          component: CodeSelectorWithRouter, levels: 7, prefix: routeConstants.modalViewEditCase, suffix: routeConstants.selectCodetableId 
        })}
        {generateRouteLevels({ 
          component: ChangeCaseTypeWithRouter, prefix: routeConstants.modalViewEditCase, suffix: routeConstants.changeCaseType 
        })}
        {generateRouteLevels({ 
          component: CodeSelectorWithRouter, prefix: routeConstants.modalViewEditCase, suffix: routeConstants.select  
        })}
      </Route>
    </Route>
    <Route path={routeConstants.codetableAdministration} element={<CodetableBaseWithRouter />}>
      {generateRouteCodetablePaths({ component: CodetableItemWithRouter, levels: 7, suffix: routeConstants.actionTypeCodeId })}
      {generateRouteCodetablePaths({ component: CodetableItemWithRouter, levels: 7, suffix: routeConstants.actionTypeCode })}
      {generateRouteCodetablePaths({ component: CodetableListWithRouter, levels: 7 })}
    </Route>

    <Route path={routeConstants.codetableAdministration} element={<CodetableBaseWithRouter />}>
      {generateRouteCodetablePaths({ component: CodetableItemWithRouter, levels: 7, suffix: routeConstants.actionTypeCodeId })}
      {generateRouteCodetablePaths({ component: CodetableItemWithRouter, levels: 7, suffix: routeConstants.actionTypeCode })}
      {generateRouteCodetablePaths({ component: CodetableListWithRouter, levels: 7 })}
    </Route>

    {generateRouteCodetablePaths({ component: LinkCodesWithRouter, levels: 7, prefix: routeConstants.codetableLinkCodesPrefix })}
    <Route path={routeConstants.codetableLinkCodes} element={<LinkCodesWithRouter />} />

    <Route path={routeConstants.indicatorFactorsAdministration} element={<IndicatorFactorsBaseWithRouter />}>
      {generateRouteCodetablePaths({ component: IndicatorFactorsItemWithRouter, levels: 7, suffix: routeConstants.actionTypeCodeId })}
      {generateRouteCodetablePaths({ component: IndicatorFactorsItemWithRouter, levels: 7, suffix: routeConstants.actionTypeCode })}
      {generateRouteCodetablePaths({ component: IndicatorFactorsListWithRouter, levels: 7 })}
    </Route>

    <Route path={routeConstants.userAdd} element={<UserEditViewWithAccessInfo />} />
    <Route path={routeConstants.userAddSection} element={<UserEditViewWithAccessInfo />} />
    <Route path={routeConstants.userEdit} element={<UserEditViewWithAccessInfo />} />
    <Route path={routeConstants.userDuplicate} element={<UserEditViewWithAccessInfo />} />
    <Route path={routeConstants.userDuplicateSection} element={<UserEditViewWithAccessInfo />} />

    <Route path={routeConstants.roleAdd} element={<RoleEditViewWithAccessInfo />}>
      <Route path={routeConstants.section} element={<RoleEditViewWithAccessInfo />} />
    </Route>
    <Route path={routeConstants.roleEdit} element={<RoleEditViewWithAccessInfo />} />
    <Route path={routeConstants.roleEditSection} element={<RoleEditViewWithAccessInfo />} />
    <Route path={routeConstants.roleDuplicate} element={<RoleEditViewWithAccessInfo />} />
    <Route path={routeConstants.roleDuplicateSection} element={<RoleEditViewWithAccessInfo />} />

    <Route path={routeConstants.textConfigurationList} element={<TextConfigurationListWithRouter />} />
    <Route path={routeConstants.textConfigurationAdd} element={<TextConfigurationFormWithRouter />} />
    <Route path={routeConstants.textConfigurationItem} element={<TextConfigurationFormWithRouter />} />

    <Route path={routeConstants.codeDescriptionList} element={<CodeDescriptionListWithRouter />} />

    <Route path={routeConstants.myDownloadsView} element={<MyDownloads />} />
    <Route path={routeConstants.importView} element={<ImportViewWithRouter />} />
    <Route path={routeConstants.messagesToUserView} element={<Messages />} />

    <Route path={routeConstants.administrationMessagesList} element={<AdministrationMessagesListWithAccessInfo />} />
    <Route path={routeConstants.administrationMessagesItem} element={<AdministrationMessageFormWithRouter />} />

    <Route path={routeConstants.dashboardAdminList} element={<DashboardAdminListWithRouter />} />
    <Route path={routeConstants.dashboardAdminItem} element={<DashboardFormWithRouer />} />
    <Route path={routeConstants.dashboardAdminItemSection} element={<DashboardFormWithRouer />} />
    <Route path={routeConstants.dashboardAdminSavedReports} element={<DashboardSavedReportsWithRouter />} />

    <Route path={routeConstants.selectSavedReports} element={<SelectSavedReport />} />
    <Route path={routeConstants.selectSavedCompanyReport} element={<SelectCompanyReport />} />
    <Route path={routeConstants.selectSavedCompanyReports} element={<SelectCompanyReport />} />
    {generateRouteCodetablePaths({ component: CodeSelectorWithRouter, levels: 7, prefix: routeConstants.selectCodetableId })}
    <Route path={routeConstants.select} element={<CodeSelectorWithRouter />} />

    <Route path={routeConstants.selectSavedDashboard} element={<SelectDashboard />} />
    <Route path={routeConstants.selectSavedDashboards} element={<SelectDashboard />} />

    <Route path={routeConstants.companyReportAdminList} element={<CompanyReportsAdminListWithAccessInfo />} />
    <Route path={routeConstants.companyReportAdminItem} element={<CompanyReportFormWithAccessInfo />} />
    <Route path={routeConstants.companyReportAdminItemSection} element={<CompanyReportFormWithAccessInfo />} />

    <Route path={routeConstants.favouriteAdminList} element={<FavouriteAdminListWithAccessInfo />} />
    <Route path={routeConstants.favouriteAdminItem} element={<FavouriteFormWithRouter />} />
    <Route path={routeConstants.favouriteAdminItemSection} element={<FavouriteFormWithRouter />} />

    <Route path={routeConstants.importSetList} element={<ImportSetsAdminListWithAccessInfo />} />
    <Route path={routeConstants.importSetAdd} element={<ImportSetFormWithAccessInfo />} />
    <Route path={routeConstants.importSetAddSection} element={<ImportSetFormWithAccessInfo />} />
    <Route path={routeConstants.importSetCodeLikeCode} element={<ImportSetFormWithAccessInfo />} />
    <Route path={routeConstants.importSetCodeLikeCodeSection} element={<ImportSetFormWithAccessInfo />} />
    <Route path={routeConstants.importSetDuplicate} element={<ImportSetFormWithAccessInfo />} />
    <Route path={routeConstants.importSetDuplicateSection} element={<ImportSetFormWithAccessInfo />} />
    <Route path={routeConstants.importSetEdit} element={<ImportSetFormWithAccessInfo />} />
    <Route path={routeConstants.importSetEditSection} element={<ImportSetFormWithAccessInfo />} />

    <Route path={routeConstants.codeMappings} element={<CodeMappingsListWithRouter />} />
    <Route path={routeConstants.importMappings} element={<ImportMappingsWithRouter />} />
    <Route path={routeConstants.importMappingsImportSetOnly} element={<ImportMappingsWithRouter />} />
    <Route path={routeConstants.importMappingsEdit} element={<ImportMappingsWithRouter />} />
    <Route path={routeConstants.logout} element={<Logout />} />

    <Route path={routeConstants.externalUrlList} element={<ExternalUrlsAdminListWithAccessInfo />} />
    <Route path={routeConstants.externalUrlAdd} element={<ExternalUrlFormWithAccessInfo />} />
    <Route path={routeConstants.externalUrlAddSection} element={<ExternalUrlFormWithAccessInfo />} />
    <Route path={routeConstants.externalUrlEdit} element={<ExternalUrlFormWithAccessInfo />} />
    <Route path={routeConstants.externalUrlEditSection} element={<ExternalUrlFormWithAccessInfo />} />

    <Route path={routeConstants.externalUrlGroupsList} element={<ExternalUrlGroupsListWithAccessInfo />} />
    <Route path={routeConstants.externalUrlGroupsAdd} element={<ExternalUrlGroupsFormWithAccessInfo />} />
    <Route path={routeConstants.externalUrlGroupsAddSection} element={<ExternalUrlGroupsFormWithAccessInfo />} />
    <Route path={routeConstants.externalUrlGroupsEdit} element={<ExternalUrlGroupsFormWithAccessInfo />} />
    <Route path={routeConstants.externalUrlGroupsEditSection} element={<ExternalUrlGroupsFormWithAccessInfo />} />

    <Route path={routeConstants.subscriberGroupsList} element={<SubscriberGroupsListWithAccessInfo />} />
    <Route path={routeConstants.subscriberGroupsAdd} element={<SubscriberGroupsFormWithAccessInfo />} />
    <Route path={routeConstants.subscriberGroupsAddSection} element={<SubscriberGroupsFormWithAccessInfo />} />
    <Route path={routeConstants.subscriberGroupsEdit} element={<SubscriberGroupsFormWithAccessInfo />} />
    <Route path={routeConstants.subscriberGroupsEditSection} element={<SubscriberGroupsFormWithAccessInfo />} />
    <Route key={routeConstants.subscriberGroupsUserMembersPrefix}
      path={routeConstants.subscriberGroupsUserMembersPrefix + ':id'}
      element={<UserMembersWithRouter />} />
    <Route path={routeConstants.subscriberGroupsUserMembers} element={<UserMembersWithRouter />} />

    <Route path={routeConstants.experienceTransferList} element={<ExperienceTransferListWithAccessInfo />} />
    <Route path={routeConstants.experienceTransferAdd} element={<ExperienceTransferFormWithAccessInfo />} />
    <Route path={routeConstants.experienceTransferEdit} element={<ExperienceTransferFormWithAccessInfo />} />
    <Route path={routeConstants.experienceTransferOperations} element={<OperationsListWithAccessInfo />} />
    
    <Route path="*" element={<NotFound />} />
  </Route>;

// Allow hot reloading of routes
if (module.hot) {
  module.hot.accept();
}
